/**
 * HTTP client for the `sources` domain.
 *
 * Centralises the calls SourcesService / AppSourcesService make to the
 * backend so:
 *  - URL composition lives in one place
 *  - error mapping is uniform (console.error + propagation)
 *  - test harnesses can stub the client without touching axios globals
 *
 * Today: nomenclatures lookup. Future: any new backend-side sources call
 * lands here.
 *
 * The WMS legend graphic fetch in SourcesService.gatherLegendInfos lives
 * outside this client — it targets the per-namespace WMS, not the
 * application's own backend, and already has its own caching layer.
 */
import axios from 'axios'

export interface NomenclatureItem {
  Id: string
  Name: string
}

export type NomenclatureMap = {[nomName: string]: NomenclatureItem[]}

export const sourcesClient = {
  /**
   * GET the full nomenclatures dictionary from the application backend.
   * Returns an empty map and logs on failure rather than rejecting — the
   * caller (AppSourcesService) treats the lookup as best-effort.
   */
  getNomenclatures: async (url: string): Promise<NomenclatureMap> => {
    try {
      const r = await axios.get<NomenclatureMap>(url)
      return r.data ?? {}
    } catch (e) {
      console.error('sourcesClient.getNomenclatures failed', e)
      return {}
    }
  }
}
